import { Box, BoxProps, Container, Flex, Heading } from '@chakra-ui/react';
import { faArrowRight } from '@fortawesome/pro-solid-svg-icons';
import { CMS } from '@waitroom/models';
import * as React from 'react';
import CmsButton from '../../../../cms/components/Button/CmsButton';
import CmsForm from '../../../../cms/components/Form/CmsForm';
import VideoOrImage from '../../../../cms/components/VideoOrImage/VideoOrImage';
import { secondaryTextColor } from '../../../../cms/utils/base';
import { isLinkDefined } from '../../../../cms/utils/sanity';
import { Icon } from '../../Icon/Icon';
import Markdown from '../../Markdown/Markdown';

const Vertical = ({
  size = '2xl',
  heading,
  content,
  contentAlign = 'center',
  image,
  video,
  form,
  invert,
  button,
  link,
  footnote,
  ...rest
}: CMS.Vertical & BoxProps): React.ReactElement | null => {
  const hasVideo = video && video.file && video.file.asset._ref;
  const hasImage = image && image.asset._ref;
  const hasButton = isLinkDefined(button);
  const hasLink = isLinkDefined(link);
  return (
    <Box {...rest}>
      <Container maxW={`container.${size}`}>
        <Flex direction="column" gap={[12, 12, 20]} alignItems="center">
          {heading || content || button || link ? (
            <Flex
              direction="column"
              w="full"
              alignItems="center"
              textAlign={contentAlign}
              rowGap={8}
              order={invert ? 1 : 0}
            >
              {heading && (
                <Heading as="h2" size="5xl" lineHeight="shorter">
                  {heading}
                </Heading>
              )}
              {content && <Markdown fontSize={['lg']}>{content}</Markdown>}
              <div>
                <Flex rowGap={1} columnGap={[8, 10]} wrap="wrap">
                  {hasButton && (
                    <CmsButton
                      data={button}
                      isButton
                      layoutBg={rest.bgColor}
                      size={['sm', 'def', 'md']}
                      minW={['150px', '150px']}
                    >
                      {button.text}
                    </CmsButton>
                  )}
                  {hasLink && (
                    <CmsButton
                      data={link}
                      layoutBg={rest.bgColor}
                      size={['sm', 'def', 'md']}
                      rightIcon={<Icon icon={faArrowRight} />}
                    >
                      {link.text}
                    </CmsButton>
                  )}
                </Flex>
                {footnote && (
                  <Markdown textAlign="center" color={secondaryTextColor(rest.bgColor)} mt={4}>
                    {footnote}
                  </Markdown>
                )}
              </div>
            </Flex>
          ) : null}
          {hasImage || hasVideo || form ? (
            <Box w="full" maxW="880px" order={invert ? 0 : 1}>
              <VideoOrImage video={video} image={image} size={[880, 660]} />
              {form && <CmsForm id={form} />}
            </Box>
          ) : null}
        </Flex>
      </Container>
    </Box>
  );
};
export default Vertical;
